import { cloneElement, isValidElement, type PropsWithChildren } from "react";
import { DocumentAttributePrefillCandidatePicker } from "~/components/domain/settings/documents/DocumentAttributePrefillCandidatePicker";
import type { DocumentAttributeWireCandidate } from "~/shared/documents/schemas/document-attribute-wiring.schema";
import { Stack } from "~/ui";

type LabelStrippableFieldProps = { label?: string };

export type DocumentAttributePrefillFieldProps = PropsWithChildren<{
  label: string;
  candidates?: DocumentAttributeWireCandidate[];
  value: string;
  onSelect: (value: string) => void;
}>;

/** Optional candidate picker above a document create-modal field. @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export const DocumentAttributePrefillField = ({ label, candidates, value, onSelect, children }: DocumentAttributePrefillFieldProps) => {
  const showPicker = Boolean(candidates && candidates.length > 1);
  const fieldChild =
    showPicker && isValidElement<LabelStrippableFieldProps>(children) ? cloneElement(children, { label: undefined }) : children;

  return (
    <Stack spacing="xs">
      {showPicker && candidates ? (
        <DocumentAttributePrefillCandidatePicker label={label} candidates={candidates} value={value} onSelect={onSelect} />
      ) : null}
      {fieldChild}
    </Stack>
  );
};
